export const categories = [
  { id: 1, slug: 'wanghong-heiliao', name: '网红黑料', description: '网红圈一手黑料，直播翻车、带货内幕、人设崩塌全记录', icon: 'ri-user-smile-line' },
  { id: 2, slug: 'mingxing-bagua', name: '明星八卦', description: '娱乐圈最新八卦，明星恋情、片场秘闻、综艺翻车一网打尽', icon: 'ri-star-line' },
  { id: 3, slug: 'shehui-redian', name: '社会热点', description: '社会热点深度揭秘，奇闻异事、内幕曝光、事件追踪', icon: 'ri-fire-line' },
  { id: 4, slug: 'yule-neimu', name: '娱乐内幕', description: '独家揭秘娱乐圈幕后故事，资本运作、资源博弈全曝光', icon: 'ri-movie-line' },
];

export const tags = [
  { id: 1, slug: '911-baoliao', name: '911爆料' },
  { id: 2, slug: 'zhibo-fanche', name: '直播翻车' },
  { id: 3, slug: 'daihuo-neimu', name: '带货内幕' },
  { id: 4, slug: 'rensheng-bengta', name: '人设崩塌' },
  { id: 5, slug: 'lianqing-bagua', name: '恋情八卦' },
  { id: 6, slug: 'zongyi-jiexi', name: '综艺揭秘' },
  { id: 7, slug: 'ziben-boqian', name: '资本博弈' },
  { id: 8, slug: 'dujia-jiemi', name: '独家揭秘' },
  { id: 9, slug: 'quanwei-paoguang', name: '全网曝光' },
  { id: 10, slug: 'shishi-zhuizong', name: '实时追踪' },
];

export const articles = [
  {
    id: 1,
    slug: 'dingji-wanghong-zhibo-fanche-neimu',
    title: '顶流网红直播间翻车事件全解析：背后资本博弈与团队内讧',
    excerpt: '一场看似偶然的直播翻车，背后牵扯出千万级对赌协议、MCN机构内斗与网红圈不为人知的潜规则。本网独家深度揭秘。',
    content: `<p>近日，坐拥三千万粉丝的顶流网红"XX酱"在直播间意外翻车，当着百万观众的面怒斥团队不作为，随后愤然下播。这一事件迅速登上各大平台热搜，引发全网热议。</p>
<p>据接近该网红团队的知情人士向本网独家透露，这次"翻车"并非偶然。背后牵扯到一份价值五千万的对赌协议，以及MCN机构内部的激烈权力斗争。</p>
<p>"XX酱"签约的MCN机构"星辰互娱"近半年来内部管理层频繁变动，原CEO于三个月前被投资人联合罢免。新任管理层对旗下主播提出了更为严苛的业绩要求，直接导致了主播与机构之间的矛盾激化。</p>
<p>更令人震惊的是，据内部邮件显示，该机构要求"XX酱"在接下来六个月内完成两亿GMV的对赌目标，否则将面临高达五千万的违约金。这种高压政策下，直播间翻车几乎是必然结果。</p>
<p>本网还独家获取了一份主播与机构之间的私下聊天记录，其中有大量关于资源倾斜不公、流量分配暗箱操作的抱怨。多位腰部主播表示，机构将90%的流量资源倾斜给头部主播，导致中小主播生存艰难。</p>
<p>业内人士分析认为，此事件很可能成为网红行业整顿的导火索。目前已有多个监管部门关注此事，或将出台针对直播带货行业的更严格规范。</p>`,
    category: 'wanghong-heiliao',
    tags: ['zhibo-fanche', 'ziben-boqian', 'dujia-jiemi'],
    author: '爆料小分队',
    publishDate: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20studio%20scene%20with%20streaming%20equipment%20ring%20light%20and%20shattered%20glass%20effect%2C%20cinematic%20lighting%20with%20red%20accents%2C%20mysterious%20atmosphere%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20high%20contrast%2C%20dark%20background%20with%20neon%20red%20glow&width=1600&height=900&seq=article-01&orientation=landscape',
    isHot: true,
    isExclusive: true,
    viewCount: 1285000,
  },
  {
    id: 2,
    slug: 'danghong-nvxing-simi-yuehui-beipaidao',
    title: '当红女星深夜私密约会遭偷拍！男方身份曝光竟是圈外大佬',
    excerpt: '狗仔队深夜蹲点拍到某85花与神秘男子亲密互动，男方被扒出竟是金融圈大佬，身家过百亿。知情人爆料两人已秘密交往半年。',
    content: `<p>娱乐圈从来不缺劲爆新闻。昨晚，知名狗仔"娱记老王"在社交平台发布了一组偷拍照片，显示某当红85花旦深夜与一位神秘男子在一家高端日料店密会。</p>
<p>照片中，两人举止亲密，用餐完毕后一同乘车离开，前往某高端住宅区。狗仔蹲守至凌晨三点，确认两人整夜未出。</p>
<p>经过本网记者的深入调查，这位神秘男子的身份终于浮出水面——他是国内某知名投资机构的创始合伙人，身家据传超过百亿，在金融圈有着"点金手"的称号。</p>
<p>知情人士透露，两人是在半年前的一场慈善晚宴上认识的。这位金融大佬对女星一见钟情，随后展开了猛烈的追求。据悉，他不仅在女星生日时送了一辆限量版法拉利，还为她专门成立了一个影视投资基金。</p>
<p>不过，这位女星的粉丝们对此反应不一。有粉丝表示祝福，认为女星年纪不小了，遇到合适的人应该把握。但也有事业粉担心恋爱会影响女星的工作安排，毕竟她目前有三部大制作待播。</p>
<p>目前，双方团队均未对此事做出回应。本网将持续关注。</p>`,
    category: 'mingxing-bagua',
    tags: ['lianqing-bagua', 'quanwei-paoguang'],
    author: '娱记老王',
    publishDate: '2026-06-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20style%20scene%2C%20luxury%20restaurant%20exterior%20at%20night%20with%20blurred%20figures%2C%20dramatic%20moody%20lighting%2C%20dark%20urban%20atmosphere%2C%20cinematic%20red%20and%20black%20color%20palette%2C%20high%20contrast%20noir%20style&width=1600&height=900&seq=article-02&orientation=landscape',
    isHot: true,
    isExclusive: false,
    viewCount: 2356000,
  },
  {
    id: 3,
    slug: 'da-xing-zongyi-jie-mu-hei-mu-bao-guang',
    title: '大型综艺节目黑幕大曝光！选手排名竟是提前内定的剧本',
    excerpt: '某热门选秀综艺被曝排名造假，知情工作人员匿名爆料节目组提前一个月就确定了最终前三名，选手们的命运早已被资本操控。',
    content: `<p>选秀综艺的"公平"到底有多少水分？一位自称在某热门选秀综艺工作了两年多的幕后工作人员，近日向本网匿名爆料，揭露了节目组在选手排名上的种种暗箱操作。</p>
<p>据这位爆料人透露，节目组在录制开始前一个月就已经确定了最终的冠亚季军人选。这些被"内定"的选手，都是背后有强大资本支持的练习生。"投票数据根本就是个笑话，后台可以随时修改。"</p>
<p>更令人震惊的是，节目组还会通过各种手段打压不受资本青睐的选手。比如故意给这些选手不适合的歌曲，或者在剪辑时删减他们的精彩表现，增加负面镜头。</p>
<p>"有一个选手唱功非常好，但因为拒绝了某赞助商的商业合作要求，直接被节目组'雪藏'了。她的镜头被剪得只剩下几秒钟，最后在第二轮就被淘汰了。"爆料人说道。</p>
<p>此事一经曝光，立即在网络上引发轩然大波。大量网友涌入节目官方社交账号留言要求解释，多个粉丝后援会也联名发表声明，要求节目组公开投票数据。</p>
<p>目前该节目组尚未对此事做出回应，但据业内人士透露，有关部门已经开始关注此事并着手调查。</p>`,
    category: 'yule-neimu',
    tags: ['zongyi-jiexi', 'ziben-boqian', 'dujia-jiemi'],
    author: '深度爆料组',
    publishDate: '2026-06-26',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20stage%20with%20spotlights%20and%20empty%20judges%20chairs%2C%20dramatic%20theatrical%20lighting%20with%20red%20hues%2C%20mysterious%20backstage%20atmosphere%2C%20cinematic%20composition%2C%20shadows%20and%20contrast&width=1600&height=900&seq=article-03&orientation=landscape',
    isHot: false,
    isExclusive: true,
    viewCount: 987000,
  },
  {
    id: 4,
    slug: 'shehui-redian-xiaoqu-wuye-jiankong-neimu',
    title: '小区物业费去向成谜！业主联合调查揭开惊人内幕',
    excerpt: '某高端小区业主发现物业费账目存在严重问题，经过数月调查，竟然发现物业公司存在虚构支出、侵占公共收益等多项违规行为。',
    content: `<p>城市里的业主们，你们知道自己交的物业费都去了哪里吗？近日，北京某高端小区的业主们在一次偶然的机会中发现，小区的物业费账目存在重大问题。</p>
<p>事情的起因是一位从事财务工作的业主，在小区的年度财务公示中发现了多处不合常理的支出项目。例如，一项标注为"绿化维护"的支出高达八十万元，但小区内只有几千平米的绿化面积。</p>
<p>这位业主随后联合了小区内其他几位有财务、法律背景的业主，组成了一个调查小组。经过数月的深入调查，他们发现了令人震惊的内幕。</p>
<p>调查显示，物业公司不仅存在虚构支出的问题，更严重的是，他们将小区公共区域的广告收益、停车费等本应属于全体业主的公共收益据为己有。初步估算，仅公共收益一项，物业公司三年内就侵占了超过五百万元。</p>
<p>目前，业主们已经联合聘请了律师，准备对物业公司提起诉讼。同时，他们也在积极推动成立正式的业主委员会，以便更好地监督物业管理。</p>
<p>此事件引发了社会对物业管理行业的广泛关注。多位法律专家表示，类似的物业纠纷在全国范围内都普遍存在，亟需相关法律法规的完善和监管的加强。</p>`,
    category: 'shehui-redian',
    tags: ['quanwei-paoguang', 'shishi-zhuizong'],
    author: '社会观察员',
    publishDate: '2026-06-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20residential%20building%20exterior%20at%20dusk%2C%20dramatic%20sky%20with%20dark%20clouds%2C%20ominous%20atmosphere%2C%20cinematic%20lighting%20with%20subtle%20red%20undertones%2C%20urban%20landscape%2C%20high%20contrast%20photography&width=1600&height=900&seq=article-04&orientation=landscape',
    isHot: false,
    isExclusive: false,
    viewCount: 756000,
  },
  {
    id: 5,
    slug: 'wangluo-zhubo-jiaju-zhibo-yiwaishi-neimu',
    title: '知名主播假酒直播事件持续发酵！供应商跑路，平台连夜删视频',
    excerpt: '某平台头部带货主播被曝销售假酒，消费者集体维权。供应商已人去楼空，直播平台紧急下架所有相关视频，面临巨额赔偿。',
    content: `<p>直播带货行业的信任危机再次升级。近日，某平台拥有两千万粉丝的头部带货主播被消费者集体举报，称其直播间销售的某品牌白酒为假冒伪劣产品。</p>
<p>事发起因是一位购买了该白酒的消费者，在饮用后出现严重不适，送往医院后被诊断为酒精中毒。经过专业检测机构的鉴定，该白酒的甲醇含量严重超标，属于典型的工业酒精勾兑的假酒。</p>
<p>消息传出后，越来越多的消费者站出来表示自己购买的同款白酒也存在问题。据不完全统计，该主播在直播间共售出该品牌白酒超过十万瓶，涉及金额高达数千万元。</p>
<p>更令人愤怒的是，当消费者试图联系供应商时发现，该公司已经人去楼空，所有联系电话均已停机。而直播平台在事发后连夜删除了该主播的所有相关直播回放视频。</p>
<p>目前，数百名受害消费者已经联合起来，准备对主播、供应商以及直播平台提起集体诉讼。法律专家表示，根据相关法律规定，主播作为商品的推荐者和销售者，需要对产品质量承担相应的法律责任。</p>
<p>此事件再次敲响了直播带货行业监管的警钟。业内人士呼吁，应尽快建立更严格的直播带货产品审核机制，保护消费者权益。</p>`,
    category: 'wanghong-heiliao',
    tags: ['daihuo-neimu', 'rensheng-bengta', 'shishi-zhuizong'],
    author: '消费维权组',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20broken%20luxury%20liquor%20bottles%20on%20a%20streaming%20setup%2C%20red%20warning%20glow%2C%20crime%20scene%20aesthetic%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%20with%20dark%20shadows&width=1600&height=900&seq=article-05&orientation=landscape',
    isHot: true,
    isExclusive: true,
    viewCount: 1890000,
  },
  {
    id: 6,
    slug: 'yingshi-quan-ziben-qianze-neimu-jiepi',
    title: '影视圈资本博弈内幕：一部电影背后的权力游戏与利益交换',
    excerpt: '深度揭秘影视投资圈不为人知的运作模式：选角不是看演技而是看资源，一部电影从立项到上映要经历多少利益交换和权力博弈。',
    content: `<p>在普通人眼中，一部电影的制作就是导演、演员、剧组共同努力的结果。但在业内人士看来，这背后是一场复杂的资本博弈。</p>
<p>本网记者采访了多位在影视行业工作超过十年的资深从业者，还原了电影制作幕后的真实面貌。</p>
<p>"选角从来就不是看演技的。一部投资过亿的电影，女主角可能早在剧本完成之前就已经确定了。"一位不愿透露姓名的选角导演告诉记者，大多数商业大片的男女主角都是由投资方指定的，导演基本没有话语权。</p>
<p>据透露，目前影视圈存在一个不成文的"资源互换"规则。某个演员能拿到一个角色，背后可能是其经纪公司承诺给投资方的其他资源，比如广告代言、综艺节目档期等。</p>
<p>更令人咋舌的是，有些电影的立项本身就是一种资本操作。通过虚报制作成本、关联交易等手段，一些投资者甚至能够在电影上映前就已经完成了套利。</p>
<p>"电影亏不亏不重要，重要的是在这个过程中的利益交换。"这位业内人士如是说。这种畸形的运作模式，严重影响了中国电影产业的健康发展。</p>`,
    category: 'yule-neimu',
    tags: ['ziben-boqian', 'dujia-jiemi', 'quanwei-paoguang'],
    author: '深度爆料组',
    publishDate: '2026-06-23',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20set%20with%20empty%20directors%20chair%20and%20film%20equipment%2C%20dramatic%20lighting%20with%20red%20and%20black%20contrast%2C%20mysterious%20atmosphere%2C%20behind%20the%20scenes%20film%20industry%2C%20high%20contrast%20photography&width=1600&height=900&seq=article-06&orientation=landscape',
    isHot: false,
    isExclusive: true,
    viewCount: 632000,
  },
  {
    id: 7,
    slug: 'duan-ship-pingtai-suanfa-jimi-liuliang-boyi',
    title: '短视频平台算法机密泄露！流量分配的潜规则让创作者心寒',
    excerpt: '一份疑似某头部短视频平台的内部算法文档在网上流出，揭示了流量分配的暗箱操作。限流、降权、人工干预等潜规则让无数创作者心寒。',
    content: `<p>短视频创作者们一直在吐槽的"限流"问题，终于有了实质性证据。近日，一份标注为某头部短视频平台内部文件的文档在网络上流传，详细记录了流量分配的算法规则和人工干预机制。</p>
<p>根据这份文档披露的信息，平台的流量分配并非完全由算法自动完成，而是存在大量的"人工加权"和"人工降权"操作。</p>
<p>例如，签约了平台独家合作协议的创作者，会自动获得额外的流量扶持——即使内容质量一般，也会被推荐给更多用户。而那些没有签约、或者得罪了平台运营的创作者，则会被悄悄地"限流"。</p>
<p>更让人震惊的是，文档中还提到了一种叫做"商业保护限流"的机制。如果某个创作者的内容对平台的广告客户构成负面影响，平台会主动降低其内容的推荐量，甚至直接屏蔽相关关键词。</p>
<p>一位拥有五百万粉丝的创作者向本网表示，她早就怀疑自己被限流了。"我的粉丝量一直在涨，但视频播放量却莫名其妙地从几百万人掉到了几十万。问平台，他们永远说是'正常波动'。"</p>
<p>目前该平台尚未对此文档的真实性做出回应，但多个独立技术团队经过分析后认为，文档中描述的技术细节与平台的实际运行机制高度吻合。</p>`,
    category: 'shehui-redian',
    tags: ['dujia-jiemi', 'quanwei-paoguang', 'shishi-zhuizong'],
    author: '科技前线',
    publishDate: '2026-06-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20digital%20abstract%20scene%20with%20algorithm%20visualization%2C%20binary%20code%20flowing%20in%20red%20and%20black%2C%20cyber%20mystery%20atmosphere%2C%20cinematic%20tech%20noir%20style%2C%20dramatic%20lighting%20with%20red%20accents&width=1600&height=900&seq=article-07&orientation=landscape',
    isHot: true,
    isExclusive: false,
    viewCount: 1560000,
  },
  {
    id: 8,
    slug: 'yule-quan-dingliu-yiren-jieyue-fengbo',
    title: '娱乐圈顶流艺人解约风波升级！天价违约金背后的行业困境',
    excerpt: '近期多位一线艺人相继与原经纪公司解约，涉及违约金高达数亿元。业内人士分析这背后是传统经纪模式的崩塌与艺人自主意识的觉醒。',
    content: `<p>娱乐圈正在经历一场前所未有的"解约潮"。据本网不完全统计，仅2026年上半年，就有超过十位一线艺人与原经纪公司解约或正在走解约流程，涉及的违约金总额超过十亿元。</p>
<p>这一现象的背后，是整个经纪行业模式的深层危机。</p>
<p>传统经纪公司通常与艺人签订长达十年甚至更久的"卖身契"，抽成比例高达70%甚至更高。在艺人尚未成名时，这种模式或许有其合理性——公司投入资源培养艺人。但当艺人成为一线明星后，这种高抽成模式就变得极不合理。</p>
<p>"一个艺人一年赚一个亿，公司拿走七千万，艺人只能拿到三千万，还要交税、养团队，最后到自己手里的可能连一千万都不到。"一位经纪行业的资深从业者向本网透露。</p>
<p>更关键的是，随着社交媒体的发展，艺人开始意识到自己才是流量的核心。有了个人社交账号，艺人可以直接与粉丝互动、接商业合作，对经纪公司的依赖度大幅降低。</p>
<p>目前，多位正在进行解约谈判的艺人都选择了成立个人工作室的模式，试图摆脱传统经纪公司的控制。但这条路并不好走，天价违约金和法律纠纷是绕不开的坎。</p>`,
    category: 'mingxing-bagua',
    tags: ['ziben-boqian', 'rensheng-bengta', 'dujia-jiemi'],
    author: '娱记老王',
    publishDate: '2026-06-21',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20broken%20contract%20papers%20and%20scattered%20money%2C%20luxury%20office%20setting%2C%20cinematic%20lighting%20with%20red%20and%20gold%20accents%2C%20corporate%20drama%20atmosphere%2C%20high%20contrast%20photography&width=1600&height=900&seq=article-08&orientation=landscape',
    isHot: false,
    isExclusive: false,
    viewCount: 890000,
  },
  {
    id: 9,
    slug: 'wangluo-daihuo-xin-guiding-yingxiang-shengcun',
    title: '网络直播新规即将实施！带货主播面临行业大洗牌',
    excerpt: '国家市场监督管理总局发布直播带货新规草案，要求主播必须实名认证、产品需提供质检报告、虚假宣传最高罚款千万。行业或将迎来史上最严监管。',
    content: `<p>直播带货行业即将迎来史上最严监管。国家市场监督管理总局日前发布了《网络直播营销活动监管暂行办法（征求意见稿）》，对直播带货行业做出了全面规范。</p>
<p>根据新规草案，所有从事直播带货的主播必须进行实名认证，并在直播页面的显著位置公示真实姓名或注册名称。此外，主播需要对所推荐的商品承担相应的法律责任。</p>
<p>在产品方面，新规要求所有在直播间销售的商品必须提供第三方质检报告。食品、化妆品、保健品等特殊品类还需要额外的许可资质。这意味着大量依靠"三无产品"赚钱的小主播将面临淘汰。</p>
<p>对于虚假宣传行为，新规的处罚力度也大幅提升。情节严重的，将被处以违法所得五倍以上十倍以下的罚款，最高可达一千万。同时，违规主播将被列入行业黑名单，禁止在任何平台从事直播带货活动。</p>
<p>业内专家表示，新规的出台将对整个行业产生深远影响。预计将有30%至50%的中小主播退出市场，行业集中度将进一步提高。但对于消费者来说，这无疑是一个好消息。</p>`,
    category: 'wanghong-heiliao',
    tags: ['daihuo-neimu', 'shishi-zhuizong', 'quanwei-paoguang'],
    author: '政策解读组',
    publishDate: '2026-06-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20scene%20with%20official%20document%20and%20red%20stamp%2C%20legal%20regulation%20theme%2C%20smartphone%20displaying%20live%20streaming%20app%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20high%20contrast%20red%20and%20black&width=1600&height=900&seq=article-09&orientation=landscape',
    isHot: true,
    isExclusive: false,
    viewCount: 1120000,
  },
  {
    id: 10,
    slug: 'yule-quan-dingliu-jingjiren-neimu-jiaoyi',
    title: '顶流经纪人私下交易遭曝光！资源分配暗藏利益输送链',
    excerpt: '某知名经纪人被曝利用职务之便，在艺人资源分配中收受回扣、暗箱操作。多位明星被卷入其中，涉及代言、影视资源等多条利益链。',
    content: `<p>娱乐圈的资源分配到底有多黑？一位业内知情人士向本网独家爆料，揭露了某顶级经纪人在资源分配中的种种暗箱操作。</p>
<p>据爆料人透露，这位经纪人是圈内公认的"资源王"，手下管理着多位一线艺人。但她真正的赚钱方式，并非来自艺人的经纪抽成，而是通过资源分配中的利益输送。</p>
<p>"一个代言合同，品牌方出价两千万，经纪人告诉艺人只有一千万，剩下的钱通过其他渠道走掉了。"爆料人说道。更可怕的是，这种操作在圈内几乎是公开的秘密。</p>
<p>除了财务问题，该经纪人在艺人的发展规划上也存在严重的利益导向。哪个项目能给她带来更多回扣，她就力推艺人去接哪个项目，完全不顾艺人的长远发展。</p>
<p>据透露，已经有多位艺人对这位经纪人不满，但敢怒不敢言。因为她在圈内的人脉实在太广，得罪她就等于自绝于整个娱乐圈。</p>
<p>本网已将相关证据提交给了行业协会，期待有关部门能够介入调查，净化娱乐圈的环境。</p>`,
    category: 'yule-neimu',
    tags: ['dujia-jiemi', 'ziben-boqian', 'rensheng-bengta'],
    author: '深度爆料组',
    publishDate: '2026-06-19',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20office%20with%20secret%20documents%20and%20envelopes%20on%20desk%2C%20mysterious%20business%20negotiation%20scene%2C%20cinematic%20noir%20lighting%20with%20red%20accents%2C%20corporate%20corruption%20theme%2C%20high%20contrast%20shadows&width=1600&height=900&seq=article-10&orientation=landscape',
    isHot: false,
    isExclusive: true,
    viewCount: 768000,
  },
  {
    id: 11,
    slug: 'shejiao-meiti-shuju-xielou-daxing-shijian',
    title: '社交媒体平台数据大规模泄露！五千万用户信息被暗网售卖',
    excerpt: '某知名社交平台被曝发生严重数据泄露事件，超过五千万用户的个人信息在暗网上被公开售卖。其中包括手机号、身份证号等敏感数据。',
    content: `<p>网络安全再响警钟。近日，网络安全研究机构发现，某知名社交平台的大量用户数据正在暗网上被公开售卖，涉及用户数量超过五千万。</p>
<p>据安全研究员分析，泄露的数据包括用户的手机号码、身份证号码、家庭住址、工作单位等高度敏感的个人信息。这些数据以每条0.5元至5元不等的价格在暗网上出售。</p>
<p>更加令人担忧的是，部分泄露数据被证实是"新鲜"数据——也就是说，这次数据泄露很可能就发生在最近几个月内，而不是历史数据被重新包装出售。</p>
<p>安全专家分析认为，这次数据泄露的源头很可能是平台内部的员工或合作方，因为泄露数据的完整度和格式都指向了内部数据库的直接导出。</p>
<p>事件曝光后，该平台股价应声下跌超过10%。大量用户涌入平台官方账号要求解释，并有多地用户表示已经向公安机关报案。</p>
<p>网络安全专家提醒广大用户，如果怀疑自己的信息可能已经泄露，应立即修改相关账号的密码，并开启两步验证。同时要警惕近期可能出现的精准诈骗电话和短信。</p>`,
    category: 'shehui-redian',
    tags: ['quanwei-paoguang', 'shishi-zhuizong', '911-baoliao'],
    author: '科技前线',
    publishDate: '2026-06-18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cyber%20security%20scene%20with%20digital%20data%20breach%20visualization%2C%20red%20warning%20signs%20on%20dark%20background%2C%20hacker%20aesthetic%2C%20dramatic%20tech%20noir%20lighting%2C%20high%20contrast%20with%20red%20accents&width=1600&height=900&seq=article-11&orientation=landscape',
    isHot: true,
    isExclusive: true,
    viewCount: 2100000,
  },
  {
    id: 12,
    slug: 'rexin-wangyou-baoliao-mingxing-shuijun-chanyelian',
    title: '热心网友爆料明星水军产业链：一条好评五毛，百万粉丝全靠买',
    excerpt: '娱乐圈水军产业链全曝光！从微博控评到豆瓣刷分，从购买假粉到制造热搜，一条完整的灰色产业链。业内人士称这是娱乐圈"公开的秘密"。',
    content: `<p>在这个流量为王的时代，你看到的明星数据有多少是真实的？一位曾在"水军公司"工作了两年的前员工向本网匿名爆料，揭开了这个庞大灰色产业链的神秘面纱。</p>
<p>据这位爆料人透露，目前市面上的水军业务已经发展成为一个高度成熟、分工明确的产业。从基础的"点赞评论"到高级的"热搜定制"，都有明确的价目表。</p>
<p>"一条微博好评五毛钱，转发一块钱。如果要上热搜，根据位置不同，价格从五万到五十万不等。"这位前员工展示了一份内部报价单。据估算，一个具有一定知名度的明星，每个月在水军上的花费至少在数十万元。</p>
<p>更令人震惊的是，除了社交平台的数据造假，影视作品的评分也被严重操纵。一部刚上映的电影，水军公司可以在一天之内刷出上万条五星好评，同样也可以给竞争对手刷大量一星差评。</p>
<p>"有时候两个明星的粉丝在网上'开战'，其实背后的水军可能都是同一家公司在操作。赚两边的钱，这不比拍戏来钱快多了？"爆料人苦笑道。</p>`,
    category: 'mingxing-bagua',
    tags: ['quanwei-paoguang', 'dujia-jiemi', 'ziben-boqian'],
    author: '深度爆料组',
    publishDate: '2026-06-17',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20scene%20of%20rows%20of%20smartphones%20with%20fake%20social%20media%20accounts%2C%20bot%20farm%20aesthetic%2C%20cinematic%20lighting%20with%20red%20glow%2C%20dramatic%20tech%20noir%20atmosphere%2C%20high%20contrast%20shadows&width=1600&height=900&seq=article-12&orientation=landscape',
    isHot: false,
    isExclusive: true,
    viewCount: 1345000,
  },
];